export default function BackIcon({ label = 'Zpět', ...restProps }) {
	return (
		<svg
			version='1.1'
			viewBox='0 0 20 14'
			aria-label={label}
			focusable={false}
			xmlns='http://www.w3.org/2000/svg'
			{...restProps}
		>
			<path
				fill='currentColor'
				d='M0.293 7.70701L6.293 13.707C6.488 13.902 6.744 14 7 14C7.256 14 7.512 13.902 7.707 13.707C7.901 13.513 7.999 13.255 8 13C8.001 12.743 7.903 12.489 7.707 12.293L3.414 8.00001H19C19.553 8.00001 20 7.55301 20 7.00001C20 6.44701 19.553 6.00001 19 6.00001H3.414L7.707 1.70701C7.902 1.51201 8 1.25601 8 1.00001C8 0.744008 7.902 0.488008 7.707 0.293008C7.513 0.0990076 7.255 0.00100758 7 7.57589e-06C6.743 -0.000992424 6.489 0.0970076 6.293 0.293008L0.293 6.29301C0.098 6.48801 0 6.74401 0 7.00001C0 7.25601 0.098 7.51201 0.293 7.70701'
			/>
		</svg>
	);
}
